import { ChatMessageItem, ChatMessageUpdateInput } from '../../graphql/API';
import { updateMessageStatus } from '../../graphql/mutations';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const updateMessageStatusApi = async (input: ChatMessageUpdateInput): Promise<ChatMessageItem> => {
  const result = await executeGql(updateMessageStatus, { input });
  return processGqlResult<ChatMessageItem>('updateMessageStatus', result);
};
